import {Grid} from '@yandex-delivery/blocks'
import type {ReactElement} from 'react'

import {Body} from '../../../components/Body/Body'
import type {VerticalsWidgetProps as Props} from '../../types'
import {useVerticals} from '../hooks/use-verticals'
import {VerticalItem} from '../VerticalItem/VerticalItem'
import * as classes from './VerticalsWidget@desktop.classes'

export function VerticalsWidget({config}: Props): ReactElement {
  const {options, field, handleChangeVertical} = useVerticals(config)

  return (
    <Body
      tail={
        <Grid xs={12} item>
          <div className={classes.wrapper.verticals}>
            {options.length !== 0
              ? options.map(itemProps => (
                  <VerticalItem
                    key={`vertical-item-${itemProps.value}`}
                    active={field.value === itemProps.value}
                    badge={itemProps.value === 'ndd_shipment' ? 'Бизнес' : undefined}
                    onClick={handleChangeVertical}
                    tag={itemProps.value === 'walking_courier' ? 'New!' : undefined}
                    {...itemProps}
                  />
                ))
              : null}
          </div>
        </Grid>
      }
    />
  )
}
